
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

// Create an instance of axios with default settings
const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

// Add a request interceptor to include the token in the headers
axiosInstance.interceptors.request.use(
  (config) => {
  const token = localStorage.getItem('userToken');
    if (token) {
      config.headers["x-access-token"] = token; // Set the token in the header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export const sendChatRequest = async (payload) => {
  try {
    const response = await axiosInstance.post("/sendChatRequest",payload);
    return response.data;
  } catch (error) {
    console.error("sendChatRequest API Error:", error);
    throw error;
  }
};
export const getAllChatRequests = async (payload) => {
  try {
    const response = await axiosInstance.post("/getAllChatRequests",payload);
    return response.data;
  } catch (error) {
    console.error("getAllChatRequests API Error:", error);
    throw error;
  }
};
export const acceptChatRequest = async (payload) => {
  try {
    const response = await axiosInstance.post("/acceptChatRequest",payload);
    return response.data;
  } catch (error) {
    console.error("acceptChatRequest API Error:", error);
    throw error;
  }
};

export const rejectChatRequest = async (payload) => {
  try {
    const response = await axiosInstance.post("/rejectChatRequest",payload);
    return response.data;
  } catch (error) {
    console.error("rejectChatRequest API Error:", error);
    throw error;
  }
};
export const getChatHistory = async (payload) => {
  try {
    const response = await axiosInstance.post("/getChatHistory",payload);
    return response.data;
  } catch (error) {
    console.error("getChatHistory API Error:", error);
    throw error;
  }
};

export const saveChat = async (payload) => {
  try {
    const response = await axiosInstance.post("/saveChat",payload);
    return response.data;
  } catch (error) {
    console.error("saveChat API Error:", error);
    throw error;
  }
};

export const getFavouriteChatUsers = async (payload) => {
  try {
    const response = await axiosInstance.post("/getFavouriteChatUsers",payload);
    return response.data;
  } catch (error) {
    console.error("getFavouriteChatUsers API Error:", error);
    throw error;
  }
};

export const getInboxUsers = async (payload) => {
  try {
    const response = await axiosInstance.post("/getInboxUsers",payload);
    return response.data;
  } catch (error) {
    console.error("getInboxUsers API Error:", error);
    throw error;
  }
};

export const getAllFavouriteUsers = async (payload) => {
  try {
    const response = await axiosInstance.post("/getAllFavouriteUsers",payload);
    return response.data;
  } catch (error) {
    console.error("getAllFavouriteUsers API Error:", error);
    throw error;
  }
};

export const saveGroupChatMessage = async (payload) => {
  try {
    const response = await axiosInstance.post("/saveGroupChatMessage",payload);
    return response.data;
  } catch (error) {
    console.error("saveGroupChatMessage API Error:", error);
    throw error;
  }
};

export const saveChatGroup = async (payload) => {
  try {
    const response = await axiosInstance.post("/saveChatGroup",payload);
    return response.data;
  } catch (error) {
    console.error("saveChatGroup API Error:", error);
    throw error;
  }
};

export const saveBlockStatus = async (payload) => {
  try {
    const response = await axiosInstance.post("/saveBlockStatus",payload);
    return response.data;
  } catch (error) {
    console.error("saveBlockStatus API Error:", error);
    throw error;
  }
};

export const removeGroupChatUser = async (payload) => {
  try {
    const response = await axiosInstance.post("/removeGroupChatUser",payload);
    return response.data;
  } catch (error) {
    console.error("removeGroupChatUser API Error:", error);
    throw error;
  }
};

export const getGroupChatHistory = async (payload) => {
  try {
    const response = await axiosInstance.post("/getGroupChatHistory",payload);
    return response.data;
  } catch (error) {
    console.error("getGroupChatHistory API Error:", error);
    throw error;
  }
};
















